class FilterCheckbox {
  form: HTMLFormElement

  constructor(form: HTMLFormElement) {
    this.form = form
    this.toggleSelectAllFilters()
    this.toggleCountOfFilters()
  }

  private toggleSelectAllFilters() {
    const buttons = this.form.querySelectorAll('.button-select-all')

    let isActive = false
    buttons.forEach(button => {
      const inputs = button.closest('.filter__item')?.querySelectorAll('input') as NodeListOf<HTMLInputElement>
      const labelSelect = button.getAttribute('data-label-select')
      const labelUnSelect = button.getAttribute('data-label-unselect')
      const event = new Event('change')

      button.addEventListener('click', () => {
        inputs[0].dispatchEvent(event)

        inputs.forEach(input => {
          if (!isActive) input.checked = true
          if (isActive) input.checked = false
        })

        if (isActive) {
          button.innerHTML = `${labelSelect}`
        }

        if (!isActive) {
          button.innerHTML = `${labelUnSelect}`
        }

        isActive = !isActive
      })
    })
  }

  private toggleCountOfFilters() {
    const buttons = this.form.querySelectorAll('.button-see-more')

    buttons.forEach(button => {
      const items = button.closest('.filter__item')?.querySelectorAll('label') as NodeListOf<HTMLElement>
      const offsetAttribute = button.getAttribute('data-offset')
      const offset = offsetAttribute && parseInt(offsetAttribute)
      const labelElem = button.querySelector('.button-see-more__label') as HTMLElement
      const labelMore = button.getAttribute('data-label-more')
      const labelLess = button.getAttribute('data-label-less')

      let isActive = false
      button.addEventListener('click', () => {
        if (isActive) {
          if (offset) {
            const splicedItems = Array.from(items).slice(Math.max(items.length - offset + 1))
            splicedItems.forEach(item => item.classList.add('is-hidden'))
            labelElem.innerHTML = `${labelMore}`
          }
        }

        if (!isActive) {
          items.forEach(item => item.classList.remove('is-hidden'))
          labelElem.innerHTML = `${labelLess}`
        }

        isActive = !isActive
      })
    })
  }
}

export default FilterCheckbox
